<template>
  <div>
    <section class="uk-section-default uk-section">
      <div class="uk-container">
        <div class="uk-grid-margin uk-grid" uk-grid>
          <div
            class="uk-grid-item-match uk-flex-middle uk-width-expand@m uk-first-column"
          >
            <div class="uk-panel uk-width-1-1">
              <div class="uk-margin uk-text-left@m uk-text-center">
                <a href="#">
                  <img
                    src="../assets/studio8.svg"
                    uk-svg
                    width="200"
                    alt="Studio8 Logo"
                  />
                </a>
              </div>
            </div>
          </div>
          <div class="uk-grid-item-match uk-flex-middle uk-width-expand@m">
            <div class="uk-panel uk-width-1-1">
              <div class="uk-text-center">
                <ul
                  class="uk-margin-remove-bottom uk-subnav uk-subnav-divider uk-flex-center"
                  uk-margin
                >
                  <li class="uk-first-column">
                    <a href="#">Event</a>
                  </li>
                  <li>
                    <a href="#">Press</a>
                  </li>
                  <li>
                    <a href="#">Karriär</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="uk-grid-item-match uk-flex-middle uk-width-expand@m">
            <div class="uk-panel uk-width-1-1">
              <div class="uk-margin uk-text-right@m uk-text-center">
                <div
                  class="uk-child-width-auto uk-grid-small uk-flex-right@m uk-flex-center uk-grid"
                  uk-grid
                >
                  <div>
                    <a
                      class="uk-link-muted uk-icon"
                      href="https://facebook.com/pages/Studio-8/501654233283339"
                      target="_blank"
                      uk-icon="icon: facebook;"
                    ></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Footer",
  mounted() {
    //
  },
  methods: {}
};
</script>
